import { createApp } from 'vue'
import router from '@/router'
import { createPinia } from '@core/stores/pinia'
import { useAuthStore } from '@core/stores/auth'
import { useGeneralStore } from '@core/stores/general'
import { createLocale } from '@core/scripts/translate'
import filters from '@core/filters'
import App from '@/App.vue'
import '@core/global'
import '@core/window'

const app = createApp(App)

app.use(createLocale({}))
app.use(createPinia())
app.use(router)

// Restore session on app load
useAuthStore().restoreSession()
useAuthStore().requestMemberInfo()
useGeneralStore().restoreSession()

app.config.globalProperties.$baseUrl = window.location.origin;
app.config.globalProperties.$currentHost = window.location.host;
app.config.globalProperties.$prefixUrl = window.$prefixUrl;
app.config.globalProperties.$moduleName = window.$moduleName;
app.config.globalProperties.$isDesktop = false;
app.config.globalProperties.$filter = filters;
app.config.globalProperties.$isPermitted = (permission?: string | null | undefined, defaultValue?: boolean): boolean => {
    // const authStore = useAuthStore();

    // return authStore.isPermitted(permission);
    return true;
}

app.mount('#app')

